// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "hr{border:none;border-top:1px solid #c3c3c3;height:1px}.cvat-spinner{margin:25% 50%}.cvat-not-found{margin:10% 25%}.cvat-text-color{color:#303030}.cvat-title{font-weight:400;font-size:21px;color:#303030;padding-top:5px}.ant-slider>.ant-slider-track{background-color:#1890ff}.ant-slider>.ant-slider-handle{border-color:#1890ff}.cvat-info-circle-icon{color:#0074d9}#root{width:100%;height:100%;display:grid;min-width:1280px}.background-kore{background-color:#bebebe}\n", ""]);
// Exports
module.exports = exports;
